import axios from "axios";
import rutas from '@/assets/utils/rutas.json';

const getAll = async ( params = {} ) => {
  
  const { 
    tokenAtencion, search, idPaciente, establecimiento, 
    page, pageSize, 
    doctor, especialidad, estadoLaboratorio,
    modalidad = '1',
    fechaDesde, fechaHasta, excel, tipoFecha, observaciones
  } = params;

  const query = `
    query getAllLaboratoriosEnviados(
      $tokenAtencion     : String,
      $modalidad         : String, 
      $establecimiento   : String, 
      $search            : String,
      $idPaciente        : ID,
      $doctor            : String,
      $especialidad      : String,
      $estadoLaboratorio : String,
      $page              : Int, 
      $pageSize          : Int,
      $mspfaltante       : String,
      $fechaDesde        : String,
      $fechaHasta        : String,
      $excel             : String,
      $tipoFecha         : String,
      $observaciones     : String
    ) {

      allEstlaboratorio(
        tokenAtencion   : $tokenAtencion,
        search          : $search, 
        idPaciente      : $idPaciente,
        establecimiento : $establecimiento, 
        especialidad    : $especialidad,
        estadoLaboratorio : $estadoLaboratorio,
        modalidad       : $modalidad,
        doctor          : $doctor,
        page            : $page, 
        pageSize        : $pageSize,
        mspfaltante     : $mspfaltante
        fechaDesde      : $fechaDesde,
        fechaHasta      : $fechaHasta,
        excel           : $excel,
        tipoFecha       : $tipoFecha,
        observaciones   : $observaciones
      ) {

        total
        status
        message
        dataarchivo

        ls4{
          id
          token
          justificacion
          fechaCreacion
          fechaProgramada

          numeroOrden
          estadoLab400
          idslaboratorios
          nordenEnterprise
          fechaResultado: fechaResultados
          urlInformeEnterprise
          urlMspCalificacion
          urlMspCalificacion1
          urlMspCalificacion2

          auxiliarMuestras {
            id
            idPersona {
              id
              primerApellido
              primerNombre
            }
          }

          estudiolab {
            id
            token
            fechaCreacion
            fechaProgramada
            modalidad{
              id
              descripcion
            }
            consultamedica{
              cita{
                id
                cobSeleccionada {
                  id
                  descripcion
                }
                fechaCita
                horaCita
                fecderivacion
                codderivacion
                urlSolLabDer
                urlsMspPaciente
                urlsMspTitular1
                urlsMspTitular2
                urlsMspTitular3
                urlDerivacion
                urlCodigoDer

              establecimiento{
                id
                Descripcion
              }

              paciente {
                id
                numHistoriaClinica
                persona {
                  identificacion
                  primerNombre
                  segundoNombre
                  primerApellido
                  segundoApellido
                }
                segsalud{
                  descripcion
                }
              }
                doctor{
                id
                  idPersona{
                    primerNombre
                    segundoNombre
                    primerApellido
                    segundoApellido
                  }
                  especialidad{
                    descripcion
                  }
                }
              }
            }
          }
        }
      }
    }
  `;

  const variables = {
    tokenAtencion,
    search,
    idPaciente,
    page,
    pageSize,
    establecimiento,
    doctor,
    especialidad,
    estadoLaboratorio,
    modalidad,
    fechaDesde,
    fechaHasta,
    excel,
    tipoFecha,
    observaciones
  };

  try{
    const response = await axios.post(rutas.axios + 'api', { query, variables });
    if(response.status !== 200) return null;

    const response2 = response.data.data.allEstlaboratorio;
    if( response2.status !== 'success' ) return null;

    const data = {
      data        : response2.ls4,
      dataarchivo : response2.dataarchivo,
      total       : response2.total
    }

    return data;

  }catch(error){
    console.error('Error al traer los laboratorios As400 enviados', error);
    return null;
  }
}


const getByToken = async (tokenLaboratorio) => {
  
  if(!tokenLaboratorio){
    console.error('no hay tokenLaboratorio');
    return null;
  }
  
  const query = `
    query GetLaboratorio400($tokenLaboratorio:String) {
      getLaboratorio400(
        tokenLaboratorio: $tokenLaboratorio
      ) {
        status
        message
        lab400 {
          id
          numeroOrden
          nordenEnterprise
          urlMspCalificacion
          urlMspCalificacion1
          urlMspCalificacion2
          urlInformeEnterprise
          idslaboratorios
          estudiolab{
            consultamedica{
              cita{
                fechaCita
                doctor{
                  especialidad {
                  descripcion
                  }
                  idPersona{
                    primerNombre
                    primerApellido
                  }
                }
                paciente{
                  persona{
                    identificacion
                    primerNombre
                    primerApellido
                    telefono
                    correo
                  }

                }
              }
              tipoEspecialidad{
                descripcion
              }
            }
          }          
        }
      }
    }
  `;

  const variables = {
    tokenLaboratorio
  };

  try{
    const response = await axios.post( rutas.axios + 'api', { query, variables } );

    if(response.status !== 200) return null;

    const response2 = response.data.data.getLaboratorio400;
    if( response2.status !== 'success' ) return null;

    const data = response2.lab400[0];

    return data;

  }catch(error){
    console.error('Error al traer los laboratorio400 token', error);
    return null;
  }
}

const create = async (estudioLabId, fields) => {

  if(!estudioLabId){
    console.error('no hay estudioLabId');
    return null;
  }
  
  const query = `
    mutation CreateLab400(
      $estudioLab   :String!
      $examenes     :String,
      $justificacion:String,
      $numeroOrden  :String
    ) {
      createLab400(
        estudioLab    : $estudioLab
        examenes      : $examenes
        justificacion : $justificacion
        numeroOrden   : $numeroOrden
      ) {
        message
        status
        laboratorioAs400 {
          id
          token
        }
      }
    }
 
  `;

  const variables = {
    ...fields,
    estudioLab   : estudioLabId,
    examenes     : fields.examenes.join(','),
  };

  try{
    const response = await axios.post( rutas.axios + 'api', { query, variables } );

    if(response.status !== 200) return null;

    const response2 = response.data.data.createLab400;
    if( response2.status !== 'success' ) return null;

    const data = response2.laboratorioAs400;
    return data;

  }catch(error){
    console.error('Error al actualizar lab as400', error);
    return null
  }
}

const updateByToken = async (tokenLab, fields) => {

  if(!tokenLab){
    console.error('no hay token');
    return null;
  }

  const query = `
    mutation ActualizarLabas400(
      $tokenLab: String!,

      $numeroOrden         : String
      $examenes            : String
      $justificacion       : String
      $fechaProgramada     : DateTime
      
      $urlMspCalificacion  : String
      $urlMspCalificacion1 : String
      $urlMspCalificacion2 : String
      $auxiliarMuestras    : String
      $codigoOrion         : String
    ) {
      actualizarLabas400(
        tokenLab            : $tokenLab,

        numeroOrden         : $numeroOrden
        examenes            : $examenes
        justificacion       : $justificacion
        fechaProgramada     : $fechaProgramada

        urlMspCalificacion  : $urlMspCalificacion,
        urlMspCalificacion1 : $urlMspCalificacion1,
        urlMspCalificacion2 : $urlMspCalificacion2,
        auxiliarMuestras    : $auxiliarMuestras
        codigoOrion         : $codigoOrion
      ) {
        status
        message
        laboratorioAs400 {
          id
          token
        }
      }
    }
  `;

  const variables = {
    tokenLab,
    ...fields,

    examenes : fields.examenes ? fields.examenes.join(',') : null,
  };


  try{
    const response = await axios.post( rutas.axios + 'api', { query, variables } );
    if(response.status !== 200) return null;
    const response2 = response.data.data.actualizarLabas400;
    if( response2.status !== 'success' ) return response2;

    const data = response2.laboratorioAs400;
    return data;

  }catch(error){
    console.error('Error al actualizar lab as400', error);
    return null
  }

}


const deleteByToken = async (tokenLab) => {

  if(!tokenLab){
    console.error('no hay token');
    return null;
  }

  const query = `
    mutation DeleteLab400(
      $tokenLab:String!
    ) {
      deleteLab400(
        tokenLab: $tokenLab
      ) {
        message
        status
        laboratorioAs400 {
          id
          token
        }
      }
    }
  `;

  const variables = {
    tokenLab
  };

  try{
    const response = await axios.post( rutas.axios + 'api', { query, variables } );
    if(response.status !== 200) return null;
    
    const response2 = response.data.data.deleteLab400;
    if( response2.status !== 'success' ) return null;

    const data = response2.laboratorioAs400;
    return data;
    
  }catch(error){
    console.error('error al eliminar el laboratorio', error);
    return null;
  }
}


const getByCodeAndEstablecimiento = async ( codigo, establecimiento, estado = '1' ) => {

  if(!codigo || !establecimiento) return null;

  const query = `
    query GetAllLabs400(
      $estado:String
      $establecimiento:ID
      $codigo:String
    ) {
      getAllLabos(
        estado:$estado
        establecimiento:$establecimiento,
        codigo:$codigo
      ) {
        total
        status
        message
        laboratorio {
          id
          token
          codigo
          descripcion
        }
      }
    }
  `;

  const variables = {
    estado,
    establecimiento,
    codigo
  };

  try{
    const response = await axios.post( rutas.axios + 'api', { query, variables } );
    if(response.status !== 200) return null;

    const response2 = response.data.data.getAllLabos;
    if( response2.status !== 'Success' ) return null;
    const data = response2.laboratorio[0] || null;

    return data;
    
  }catch(error){
    console.error('Error al obtener el lab por codigo', error);
    return null;
  }
}


const searchLab = async ( search, establecimiento, estado = '1' ) => {

  if(!search || !establecimiento) return null;

  const query = `
    query GetAllLabs(
      $estado         :String
      $establecimiento:ID
      $search         :String
    ){
      getAllLabos(
        estado:$estado
        establecimiento:$establecimiento,
        search:$search
      ) {
        total
        status
        message
        laboratorio {
          id
          token
          codigo
          descripcion
        }
      }
    }
  `;

  const variables = {
    estado,
    establecimiento,
    search
  };

  try{
    const response = await axios.post( rutas.axios + 'api', { query, variables } );
    if(response.status !== 200) return null;

    const response2 = response.data.data.getAllLabos;
    if( response2.status !== 'Success' ) return null;
    const data = response2.laboratorio;

    return data;
    
  }catch(error){
    console.error('Error al obtener el lab por codigo', error);
    return null
  }
}


const getExamensById = async ( idLaboratorio ) => {

  if( !idLaboratorio ) {
    console.error('id laboratorio es requerido');
    return null
  }

  const query = `
    query GetAllLabos($idLaboratorio: ID) {
    getAllLabos(idLaboratorio: $idLaboratorio) {
        total
        status
        message
        laboratorio {
          id
          token
          codigo
          descripcion
          areaanalisis {
            descripcion
          }
        }
      }
    }
  `;

  const variables = {
    idLaboratorio
  };

  try {
    const response = await axios.post(rutas.axios + 'api', { query, variables });
    const response2 = response.data.data.getAllLabos;
    if( response2.status !== 'Success' ) return null;
    if( response2.laboratorio.length === 0 ) return null;

    const data = response2.laboratorio[0];
    return data;

  }catch (error) {
    console.error('Error al traer las imagenes de la atencion', error);
    return null;
  }
}


const saveLaboratorios = async (dataLab) => {

  // "dataLaboratorios":{
  //   "accion":"crear",
  //   "tokenAtencion":"",
  //   "estudioLab":"9371",
  //   "numeroOrden":"44444",
  //   "examenes":"716",
  //   "justificacion":"mi justificacion"
  // }


  if(!dataLab) return null;

  const query = `
    mutation SaveLaboratorios400(
      $dataLaboratorios: [Laboratorio400Input!]!
    ) {
    saveLaboratorios400(
      dataLaboratorios: $dataLaboratorios
    ) {
        lab400
        message
        status
      }
    }
  `;


  const variables = {
    dataLaboratorios: dataLab
  }


  try{
    const response = await axios.post(rutas.axios + 'api', { query, variables });

    if(response.status !== 200) return null;
    console.log('response', response);

  }catch(error){
    console.error('error al guardar los laboratorios 400', error);
    return null;
  }
}



const getByAtencion = async (tokenAtencion) => {

  if( !tokenAtencion ) {
    console.error('token atencion es requerido');
    return null
  }

  const response = await getAll({ tokenAtencion });
  if(!response) return null;
  const data = response.data;
  return data;
}


export const labAs400Service = {
  getAll,
  getByToken,
  create,
  updateByToken,
  deleteByToken,
  searchLab,
  getByCodeAndEstablecimiento,
  getExamensById,


  getByAtencion,

  saveLaboratorios
}
